import { DictionaryUtil } from "@goodgamestudios/core";
import { MathBase } from "@goodgamestudios/core";

import { int } from "@goodgamestudios/math-utilities";

import { VOHelper } from "../../../basic/vo/VOHelper";

import { Poker2Constants } from "../../constants/Poker2Constants";
import { Poker2AvatarEvent } from "../../event/Poker2AvatarEvent";
import { AvatarVO } from "../../gamevo/AvatarVO";
import { ItemsVO } from "../../gamevo/ItemsVO";
import { ShopVO } from "../../gamevo/ShopVO";
import { Poker2Model } from "../Poker2Model";
import { BasicData } from "./BasicData";

export class Poker2AvatarData extends BasicData {
    private _myAvatarVO: AvatarVO;

    constructor() {
        super();
    }

    public parse_AVATAR(paramObject: any): void {
        if (!paramObject)
            return;
        this._myAvatarVO = this.parseAvatar(paramObject.gender, paramObject.allowGiveChips, paramObject.items);
        this.controller.dispatchEvent(new Poker2AvatarEvent("avatarChanged"));
    }

    public parseAvatar(gender: string, allowGiveChips: boolean, items: string): AvatarVO {
        var avatarVO: AvatarVO = new AvatarVO();
        avatarVO.gender = gender;
        avatarVO.allowGiveChips = allowGiveChips;
        avatarVO.avatarWear = new Map<any, any>();
        if (items.length > 0) {
            var avatarClothes: any[] = items.split("#");
            for (var j: number = 0; j < avatarClothes.length; j++) {
                var avatarParams: any[] = String(avatarClothes[j]).split("+");
                var id: number = int(avatarParams.shift());
                var colorId: number = int(avatarParams.shift());
                this.addItem(id, colorId, avatarVO);
            }
        }
        this.minimalClothes(avatarVO);
        return avatarVO;
    }

    public get myAvatar(): AvatarVO {
        return this._myAvatarVO;
    }
    public set myAvatar(value: AvatarVO) {
        this._myAvatarVO = value;
    }

    public switchItem(itemVO: ItemsVO, avatarVO: AvatarVO, ignoreDoubleItems: boolean = false): void {
        if (!ignoreDoubleItems && this.hasItem(itemVO.id, itemVO.colorId, avatarVO)) {
            // Item löschen, wenn bereits vorhanden
            // Kein Minimum-Item löschen (background, skin, nose...)
            if (Poker2Constants.ITEM_CATEGORIES_MINIMALCLOTH.indexOf(itemVO.itemCategory) < 0) {
                this.removeItem(itemVO.id, avatarVO);
                this.minimalClothes(avatarVO);
            }
            return;
        }

        var removeCategories: any[] = new Array();
        // Neues KleidungsItem, wenn bereits ein Kostüm vorhanden dieses löschen
        if (this.containsItemOfItemCategory("costume", avatarVO)) {
            var costumeVO: ItemsVO = this.getItemByCategory("costume", avatarVO);
            if (itemVO.itemCategory == "hair" && costumeVO.hasHair)
                removeCategories.push("costume");
            if (Poker2Constants.ITEM_CATEGORIES_NONCOSTUME.indexOf(itemVO.itemCategory) >= 0)
                removeCategories.push("costume");
        }

        // Neues Kostüm, alle KleidungsItems löschen
        if (itemVO.itemCategory == "costume") {
            if (itemVO.hasHair)
                removeCategories.push("hair");

            for (var j: number = 0; j < Poker2Constants.ITEM_CATEGORIES_NONCOSTUME.length; j++)
                removeCategories.push(Poker2Constants.ITEM_CATEGORIES_NONCOSTUME[j]);
        }

        // Neues Bottom KleidungsItem, wenn bereits eine entsprechende Unterwäsche vorhanden dieses löschen
        if (Poker2Constants.ITEM_CATEGORIES_BOTTOMUNDERWEAR.indexOf(itemVO.itemCategory) >= 0 && this.containsItemOfItemCategory("underwearBottom", avatarVO))
            removeCategories.push("underwearBottom");
        // Neues Top KleidungsItem, wenn bereits eine entsprechende Unterwäsche vorhanden dieses löschen
        if (Poker2Constants.ITEM_CATEGORIES_TOPUNDERWEAR.indexOf(itemVO.itemCategory) >= 0 && this.containsItemOfItemCategory("underwearTop", avatarVO))
            removeCategories.push("underwearTop");

        // Item der gleichen Itemkategorie löschen
        if (this.containsItemOfItemCategory(itemVO.itemCategory, avatarVO))
            removeCategories.push(itemVO.itemCategory);

        for (var i: number = 0; i < removeCategories.length; i++)
            this.removeItemOfItemCategory(removeCategories[i], avatarVO);

        this.addItem(itemVO.id, itemVO.colorId, avatarVO);

        if (itemVO.itemCategory != "costume")
            this.minimalClothes(avatarVO);
    }

    private minimalClothes(avatarVO: AvatarVO): void {
        // Wenn Avatar keine Bottom KleidungsItems mehr hat, Unterwäsche anziehen
        if (!this.containsItemOfItemCategories(Poker2Constants.ITEM_CATEGORIES_BOTTOMUNDERWEAR, avatarVO))
            this.addItem(Poker2Model.itemShop.getBottomUnderwearIdByGender(avatarVO.gender), -1, avatarVO);
        // Wenn Avatar keine Top KleidungsItems mehr hat, Unterwäsche anziehen
        if (!this.containsItemOfItemCategories(Poker2Constants.ITEM_CATEGORIES_TOPUNDERWEAR, avatarVO))
            this.addItem(Poker2Model.itemShop.getTopUnderwearIdByGender(avatarVO.gender), -1, avatarVO);
        // Wenn Avatar keine Haare mehr hat, eine Frisur aus Inventar anziehen
        if (!this.containsItemOfItemCategories(["hair"], avatarVO)) {
            if (this.containsItemOfItemCategory("costume", avatarVO)) {
                var costumeVO: ItemsVO = this.getItemByCategory("costume", avatarVO);
                if (costumeVO.hasHair)
                    return;
            }
            var hairItems: any[] = Poker2Model.inventoryData.getInventoryBySubCategory("shopHair");
            var randomIndex: number = int(MathBase.random(0, hairItems.length - 1));
            var hairItemVO: ItemsVO = hairItems[randomIndex];
            this.addItem(hairItemVO.id, hairItemVO.colorId, avatarVO);
        }
    }

    private addItem(id: number, colorId: number, avatarVO: AvatarVO): void {
        var avatarClothClone: ItemsVO = castAs<ItemsVO>(Poker2Model.wodData.getItemVObyID(id), "ItemsVO");
        if (avatarClothClone == null)
            return;
        var avatarClothes: ItemsVO = VOHelper.clone(avatarClothClone) as ItemsVO;
        avatarClothes.colorId = colorId;
        avatarClothes.currentColor = Poker2Model.itemShop.getColorById(colorId);
        avatarVO.avatarWear.set(id, avatarClothes);
    }

    private removeItem(wodId: number, avatarVO: AvatarVO, amount: number = 1): void {
        if (DictionaryUtil.containsKey(avatarVO.avatarWear, wodId)) {
            if (avatarVO.avatarWear.get(wodId).inventoryAmount <= amount)
                avatarVO.avatarWear.delete(wodId);
            else
                avatarVO.avatarWear.get(wodId).inventoryAmount -= amount;
        }
    }

    public getAvatarClothesArray(avatar: AvatarVO): any[] {
        var result: any[] = new Array();
        for (let entryList of Array.from(avatar.avatarWear.values())) {
            var itemVO: any = entryList;
            if (itemVO === undefined) { continue; }

            result.push(itemVO);
        }
        return result;
    }

    public hasItem(id: number, colorId: number, avatarVO: AvatarVO): boolean {
        if (DictionaryUtil.containsKey(avatarVO.avatarWear, id))
            return colorId < 0 || ((avatarVO.avatarWear.get(id) as ShopVO).colorId == colorId);
        return false;
    }

    private containsItemOfItemCategory(itemCategory: string, avatarVO: AvatarVO): boolean {
        for (let entryList of Array.from(avatarVO.avatarWear.values())) {
            var value: any = entryList;
            if (value === undefined) { continue; }

            if (value.itemCategory == itemCategory)
                return true;
        }
        return false;
    }

    public getItemByCategory(itemCategory: string, avatarVO: AvatarVO): ItemsVO {
        for (let entryList of Array.from(avatarVO.avatarWear.values())) {
            var value: any = entryList;
            if (value === undefined) { continue; }

            if (value.itemCategory == itemCategory)
                return value;
        }
        return null;
    }

    private containsItemOfItemCategories(itemCategories: any[], avatarVO: AvatarVO): boolean {
        for (let entryList of Array.from(avatarVO.avatarWear.values())) {
            var value: any = entryList;
            if (value === undefined) { continue; }

            if (itemCategories.indexOf(value.itemCategory) >= 0)
                return true;
        }
        return false;
    }

    public removeItemOfItemCategory(itemCategory: string, avatarVO: AvatarVO): void {
        for (let entryList of Array.from(avatarVO.avatarWear.values())) {
            var value: any = entryList;
            if (value === undefined) { continue; }

            if (value.itemCategory == itemCategory)
                avatarVO.avatarWear.delete(value.id);
        }
    }

}

import { castAs } from "@goodgamestudios/createjs-utilities";
